/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export enum ESignProviders {
  DOCUSIGN = 'DOCUSIGN',
  EORIGINAL = 'EORIGINAL',
  ONESPAN = 'ONESPAN',
}

export enum DocumentStatus {
  CREATED = 'CREATED',
  DELIVERED = 'DELIVERED',
  SIGNED = 'SIGNED',
  EDITING = 'EDITING',
  DISCARDED = 'DISCARDED',
  VOIDED = 'VOIDED',
  UNKNOWN = 'UNKNOWN',
  PENDING_REVIEW = 'PENDING_REVIEW',
  COMPLETED = 'COMPLETED',
}

export enum DocumentSigningType {
  ENOTE = 'ENOTE',
  NOTARIZE = 'NOTARIZE',
  ESIGN = 'ESIGN', // requires signatures but not notarization
}

export enum RonEnvelopeStatus {
  /** An edit URL was generated and the browser is redirected DocuSign for tagging */
  TAGGING_IN_PROGRESS = 'TAGGING_IN_PROGRESS',
  /** After the user finishes tagging and clicks on Save/Close, the post-processing of the envelope was triggered. */
  FINALIZING_TAGGING = 'FINALIZING_TAGGING',
  /** Post-processing of tagging failed */
  FINALIZE_TAGGING_FAILED = 'FINALIZE_TAGGING_FAILED',
  /** The post-processing finished. New tabs are persisted. */
  TAGGING_FINISHED = 'TAGGING_FINISHED',
  /** Tagging envelope is being prepared to be sent for signing. */
  PREPARING_SIGNING = 'PREPARING_SIGNING',
  /** Envelope has been sent and is being used for signing. */
  SIGNING = 'SIGNING',
  /** Envelope documents are completed. */
  COMPLETED = 'COMPLETED',
}
